import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import isEmpty from 'lodash/isEmpty'
import intersection from 'lodash/intersection'
import ListItem from '@pc/components/Works/Panel/shared/list/ListItem'
import ListItemParagraph from '@pc/components/Works/Panel/shared/list/ListItemParagraph'
import ListItemName from '@pc/components/Works/Panel/shared/list/ListItemName'
import ListItemDescription from '@pc/components/Works/Panel/shared/list/ListItemDescription'
import OccupationCheckboxes from './OccupationCheckBoxes'
import ListOpenIcon from '@pc/components/Works/Panel/shared/list/ListOpenIcon'
import ListCloseIcon from '@pc/components/Works/Panel/shared/list/ListCloseIcon'
import type { BigCategory, SmallCategory } from '@pc/components/Works/Panel/type'

interface PropsType {
  selectedJobIds: string[]
  changeJobIds: (arg: string[]) => void
  bigCategory: BigCategory
  smallCategories: SmallCategory[]
}

const OccupationListItem = styled(ListItem)`
  cursor: pointer;
`

const OccupationListItemParagraph = styled(ListItemParagraph)`
  align-items: center;
  display: flex;
  position: relative;
  width: 100%;

  svg {
    position: absolute;
    right: 15px;
  }
`

const OccupationListItemName = styled(ListItemName)`
  font-weight: bold;
  min-width: 250px;
`

const OccupationListDescription = styled(ListItemDescription)`
  margin-right: 30px;
`

const BigOccupationItem = (props: PropsType) => {
  const { bigCategory, smallCategories, selectedJobIds, changeJobIds } = props
  const [childrenIsOpen, setChildrenIsOpen] = useState(false)

  const isSelectedBeforehand = () => {
    return !isEmpty(
      intersection(
        smallCategories.map((smallCategory) => smallCategory.attributes.id.toString()),
        selectedJobIds
      )
    )
  }

  const toggleChildren = (e: React.MouseEvent) => {
    e.preventDefault()
    setChildrenIsOpen(!childrenIsOpen)
  }

  const joinSmallCategorieNames = smallCategories.map((smallCategory) => smallCategory.attributes.name).join('、')

  useEffect(() => {
    if (isSelectedBeforehand()) {
      setChildrenIsOpen(true)
    }
  }, [])

  return (
    <OccupationListItem>
      <OccupationListItemParagraph onClick={toggleChildren}>
        <OccupationListItemName>{bigCategory.attributes.name}</OccupationListItemName>
        <OccupationListDescription>{joinSmallCategorieNames}</OccupationListDescription>
        {childrenIsOpen ? <ListCloseIcon /> : <ListOpenIcon />}
      </OccupationListItemParagraph>
      {childrenIsOpen ? (
        <OccupationCheckboxes
          bigCategory={bigCategory}
          smallCategories={smallCategories}
          selectedJobIds={selectedJobIds}
          changeJobIds={changeJobIds}
        />
      ) : null}
    </OccupationListItem>
  )
}

export default BigOccupationItem
